import React from "react";
import Header from "../Components/Header";

const CGU = () => {
    return (
        <>
            <Header title={"CGU"}></Header>
            <div className="cgu-container">
                <h1>Conditions Générales d'Utilisation</h1>
                <p><strong>En vigueur au 13/12/2024</strong></p>

                <section>
                    <h2>Article 1 : Les mentions légales</h2>
                    <p>
                        L’édition et la direction de la publication du site <strong>scfps.fr</strong> est assurée par Smigetzki Yannick, domicilié à Valenciennes.<br />
                        Numéro de téléphone : 0951092832<br />
                        Adresse e-mail : yannick.smigetzki@scfps.fr.<br />
                        L'hébergeur du site est la société OVH, située au 2, rue Kellermann, 59100 Roubaix, téléphone : 0972101007.
                    </p>
                </section>

                <section>
                    <h2>Article 2 : Accès au site</h2>
                    <p>
                        Le site <strong>scfps.fr</strong> permet un accès gratuit aux services suivants :
                        <ul>
                            <li>Accéder aux différentes formations dispensées chez SCFPS</li>
                            <li>Accéder au blog tenu par SCFPS</li>
                            <li>Accéder au calendrier des formations</li>
                        </ul>
                        Le site est accessible gratuitement à tout utilisateur disposant d’un accès à Internet. Tous les frais pour accéder au service sont à la charge de l’utilisateur.
                    </p>
                </section>

                <section>
                    <h2>Article 3 : Collecte des données</h2>
                    <p>
                        Le site respecte la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés. L’utilisateur dispose d’un droit d’accès, de rectification, de suppression et d’opposition de ses données personnelles.
                    </p>
                </section>

                <section>
                    <h2>Article 4 : Propriété intellectuelle</h2>
                    <p>
                        Les marques, logos, et contenus du site (textes, images, sons) sont protégés par le Code de la propriété intellectuelle. Toute utilisation non autorisée est interdite.
                    </p>
                </section>

                <section>
                    <h2>Article 5 : Responsabilité</h2>
                    <p>
                        Le site <strong>scfps.fr</strong> ne garantit pas l’exactitude des informations diffusées. Il ne peut être tenu responsable des erreurs ou omissions, ni des dommages causés par l’utilisation du site.
                    </p>
                </section>

                <section>
                    <h2>Article 6 : Liens hypertextes</h2>
                    <p>
                        En cliquant sur des liens hypertextes présents sur le site, l’utilisateur quitte le site <strong>scfps.fr</strong>. Ce dernier ne peut être tenu responsable des contenus des pages liées.
                    </p>
                </section>

                <section>
                    <h2>Article 7 : Cookies</h2>
                    <p>
                        Le site peut installer des cookies pour améliorer l’expérience utilisateur. L’utilisateur peut désactiver les cookies via les paramètres de son navigateur.
                    </p>
                </section>

                <section>
                    <h2>Article 8 : Droit applicable et juridiction compétente</h2>
                    <p>
                        La législation française s’applique aux présentes CGU. En cas de litige, seuls les tribunaux français sont compétents.
                    </p>
                </section>

                <footer>
                    <p>CGU réalisées sur <a href="http://legalplace.fr/" target="_blank" rel="noopener noreferrer">legalplace.fr</a></p>
                </footer>
            </div></>
    );
};

export default CGU;
